/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ import { Grid } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/pt-BR';

import api from '../../../../service/axios/api';
import { LowTable } from './LowTable';

export function Low({ setLoading, setMsg }) {
  const [dataCategory, setdataCategory] = useState([]);
  // const [selected, setSelected] = useState([]);
  const [selectedStartDate, handleStartDateChange] = useState(new Date());
  const [selectedEndDate, handleEndDateChange] = useState(new Date());

  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);

  const templateDownload = () => {
    setMsg(
      `Gerando planilha, isso pode levar alguns ${
        total > 100000 ? 'minutos' : 'segundos'
      }...`,
    );
    setLoading(true);
    api.order
      .summaryLowXls(
        selectedStartDate.toISOString(),
        selectedEndDate.toISOString(),
      )
      .then(res => {
        const url = res.data.retorno.link;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'liberacoes.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setMsg('Buscando liberações...');
    setLoading(true);
    api.order
      .summaryLow(
        selectedStartDate.toISOString(),
        selectedEndDate.toISOString(),
        page + 1,
        itens,
      )
      .then(res => {
        setdataCategory(res.data.docs);
        setTotal(res.data.total);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [selectedStartDate, selectedEndDate, page, itens]);

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '40px',
        }}
      >
        <h3>Baixas de pagamento</h3>
        <div
          style={{
            marginTop: '8px',
            display: 'flex',
            flexDirection: 'row',
            gap: 5,
            alignItems: 'center',
          }}
        >
          <div>
            <h6>Data início</h6>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                // views={['year', 'month']}
                variant="inline"
                maxDate={selectedEndDate || new Date()}
                inputVariant="outlined"
                // style={{ backgroundColor: '#fff' }}
                size="small"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={selectedStartDate}
                onChange={date => handleStartDateChange(date)}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div>
            <h6>Data fim</h6>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                // views={['year', 'month']}
                variant="inline"
                minDate={selectedStartDate}
                maxDate={new Date()}
                inputVariant="outlined"
                // style={{ backgroundColor: '#fff' }}
                size="small"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={selectedEndDate}
                onChange={date => handleEndDateChange(date)}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </Grid>

      <Grid style={{ marginBottom: '20px', marginLeft: '10px', width: '100%' }}>
        <LowTable
          docs={dataCategory}
          total={total}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          selectedDate={selectedStartDate}
          getXls={templateDownload}
        />
      </Grid>
    </>
  );
}
